import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  DeferLoadingStrategy,
  I18nModule,
  UrlModule,
  provideConfig,
} from '@spartacus/core';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { PopoverModule } from '../popover';
import { TooltipTextModule } from './../tooltip-text/tooltip-text.module';
// tslint:disable-next-line: max-line-length
import { ExplodedViewPopoverProductListingComponent } from './exploded-view-product-listing/exploded-view-popover-product-listing.component';
// tslint:disable-next-line: max-line-length
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { ExplodedViewProductListingComponent } from './exploded-view-product-listing/exploded-view-product-listing.component';
import { ShimanoExplodedViewComponent } from './shimano-exploded-view.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    NgbDropdownModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    SharedModule,
    PopoverModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    UrlModule,
    TooltipTextModule,
    RouterModule.forChild([
      {
        path: 'product/:code/:name/exploded-view/:explodedViewId',
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { pageLabel: '/exploded-view' },
      },
      {
        path: 'product/:code/exploded-view/:explodedViewId',
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { pageLabel: '/exploded-view' },
      },
    ]),
    ConfigModule.withConfig({
      cmsComponents: {
        ExplodedViewComponent: {
          component: ShimanoExplodedViewComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    ExplodedViewProductListingComponent,
    ExplodedViewPopoverProductListingComponent,
  ],
  exports: [ExplodedViewProductListingComponent, ExplodedViewPopoverProductListingComponent],
  providers: [
    provideConfig({
      ...LaunchDialogModalLayoutConfig.BackOrderCart,
    }),
  ],
})
export class ShimanoExplodedViewModule {}
